import { createCookie, readCookie } from '../../../shared/js/helpers/read-write-cookies';
import { lockBody, unlockBody } from "../../../shared/js/helpers/body-lock-toggle";

let promptUnfavourite = readCookie('prompt-unfavourite') ?? 'true';

window.addEventListener('load', event => {
    let favouriteCookies = [];
    const mobileState = window.matchMedia('(max-width: 768px)');
    var touchstartX = null;
    var touchstartY = null;
    var touchendX = null;
    var touchendY = null;
    const sensitivity = 50;
    const limit = 12;
    var offsets = {};
    const maxMobilePins = 2;
    let lockSlide = false;

    try {
        favouriteCookies = JSON.parse(readCookie('favourites') ?? '[]');
        if (!Array.isArray(favouriteCookies)) {
            favouriteCookies = [];
        }
    } catch (err) {
        favouriteCookies = [];
    }

    const wrap = (value, min, max) => {
        let output = value;

        if (value < min) {
            output = max;
        } else if (value > max) {
            output = min;
        }

        return output;
    }

    const updateHeaderFavourites = (adjustmentValue) => {
        // Flash the favourites button in the site header
        const animationTime = 200; // milliseconds, matches animation in _favourites-panel.scss
        const headerLinks = document.querySelectorAll('.favourites-header-link');

        headerLinks.forEach((headerLink) => {
            headerLink.classList.add('flash');

            const countEle = headerLink.querySelector('.favourites-count');
            let count = Number(countEle.innerText) || 0;
            count = Math.max(count+adjustmentValue, 0);

            if (count > 0) {
                headerLink.querySelector('svg')?.classList.add('scale-150');
            } else {
                headerLink.querySelector('svg')?.classList.remove('scale-150');
            }

            headerLink.querySelector('.favourites-count').innerText = count ? count : '';
        });

        setTimeout(() => {
            headerLinks.forEach((headerLink) => {
                headerLink.classList.remove('flash');
            });
        }, animationTime);
    };

    const unFavouriteItem = (button) => {
        favouriteCookies.splice(favouriteCookies.indexOf(button.dataset.favouriteId), 1);

        button.classList.remove('gtm-unfavourite');
        button.classList.add('gtm-favourite');
        button.dataset.active = 'false';

        createCookie('favourites', JSON.stringify(favouriteCookies), 365);
        updateHeaderFavourites(-1);

        // is this our MyFavourites page?
        const category = button.closest('div[data-category-id]');
        if (category) {
            const categoryTitle = category.getAttribute('data-category-id');

            const buttonCounter = document.querySelector(`#favouritesPanel .favourite-categories button[data-category="${categoryTitle}"] > span`);
            const headerCounter = category.querySelector(`.favourites-counter`);

            buttonCounter.innerText = buttonCounter.textContent.replace(/\d+/,(val) => parseInt(val) - 1);
            headerCounter.innerText = headerCounter.textContent.replace(/\d+/,(val) => parseInt(val) - 1);
        }
    }

    const hideDivsWhenNoFavourites = (categoryDiv) => {
        let favouritableCount = categoryDiv?.querySelectorAll('.favouritable').length;

        if (favouritableCount <= 1) {
            categoryDiv.querySelector('.slider-buttons')?.classList?.add('hidden');
        }

        if (favouritableCount === 0) {
            let hideWhenEmpty = categoryDiv.querySelectorAll('.favourites-hide-when-empty');
            let showWhenEmpty = categoryDiv.querySelectorAll('.favourites-show-when-empty');
            hideWhenEmpty?.forEach((div) => {
                div.classList?.add('hidden');
            });
            showWhenEmpty?.forEach((div) => {
                div.classList?.remove('hidden');
            });
        }
    }

    const removeFavouritable = (favouritable) => {
        let id = favouritable?.getAttribute('data-id');
        let categoryDiv = favouritable?.closest('[data-category-id]')
        let pin = categoryDiv?.querySelector(`[data-mobile-pin-item-id='${id}']`);
        if (pin) {
            pin?.parentElement?.removeChild(pin);
            if (mobileState.matches) {
                categoryDiv.querySelector(".btn-next")?.click();
            }
            updateMobilePinsCount(categoryDiv);
        }
        let slide = favouritable?.parentElement;
        if (slide) {
            if (mobileState.matches) {
                moveSliderRight(slide);
                slide.parentElement?.removeChild(slide);
            } else {
                slide.parentElement?.removeChild(slide);
                const slides = categoryDiv.querySelectorAll('.slide');
                if (slides.length) {
                    slides[0].classList.add('shown-in-slider');
                }
                adjustSlidePosition(categoryDiv, 0);
            }
        }

        hideDivsWhenNoFavourites(categoryDiv);
    }

    const adjustSlidePosition = (categoryDiv, curSlide, excludedSlide = null) => {
        let slides = categoryDiv?.querySelectorAll('.slide');
        setSlidesTranslateX(slides, curSlide, excludedSlide);
    }

    const setSlidesTranslateX = (slides, slideIndexAtX0, excludedSlide = null) => {
        slides?.forEach((slide, indx) => {
            if (slide !== excludedSlide) {
                let curPosition = indx - slideIndexAtX0;
                let transform = `translateX(${100 * (curPosition)}%)`;
                if (!mobileState.matches) {
                    let remOffset = 2 * curPosition;
                    transform = `translateX(calc(${100 * (curPosition)}% + ${remOffset}rem))`;
                }
                slide.style.transform = transform;
                updateSliderTitle(slide, curPosition);
            }
        });
    }

    const moveSlider = (curSlideDiv, moveRight) => {
        if (mobileState.matches) {
            moveMobileSlider(curSlideDiv, moveRight);
        } else {
            moveDesktopSlider(curSlideDiv, moveRight);
        }
    }

    const moveMobileSlider = (curSlideDiv, moveRight) => {
        let categoryDiv = curSlideDiv.closest('[data-category-id]');
        var slides = [...categoryDiv.querySelectorAll(".slide")];
        let maxSlide = slides.length - 1;
        let curSlideIndex = [...categoryDiv.querySelectorAll('.slide')].indexOf(curSlideDiv);
        let moveCount = moveRight ? 1 : -1;
        let nextSlideIndex = wrap(curSlideIndex + moveCount, 0, maxSlide);
        let nextSlideDiv = slides[nextSlideIndex];
        slides.forEach((slide) => {
            slide?.classList.remove('shown-in-slider');
        });
        nextSlideDiv?.classList.add('shown-in-slider');
        let endSlide = moveRight ? maxSlide : 0;
        if (curSlideIndex === endSlide) {
            // Append the next slide beside the currentSlide before animating.
            if (moveRight) {
                curSlideDiv?.parentElement?.appendChild(nextSlideDiv);
            } else {
                curSlideDiv?.parentElement?.insertBefore(nextSlideDiv, curSlideDiv);
            }
            curSlideIndex = [...categoryDiv.querySelectorAll('.slide')].indexOf(curSlideDiv);
            adjustSlidePosition(categoryDiv, curSlideIndex);
            // Delay is needed to ensure that the new positioning is in place
            setTimeout(() => {
                nextSlideIndex = [...categoryDiv.querySelectorAll('.slide')].indexOf(nextSlideDiv);
                adjustSlidePosition(categoryDiv, nextSlideIndex);
            }, 50)
        } else {
            adjustSlidePosition(categoryDiv, nextSlideIndex);
        }
    };

    const moveDesktopSlider = (curSlideDiv, moveRight) => {
        const categoryDiv = curSlideDiv.closest('[data-category-id]');
        const slides = [...categoryDiv.querySelectorAll(".slide")];
        const maxSlide = slides.length - 1;
        let minSlide = 0;
        const moveCount = moveRight ? 1 : -1;

        const pin = categoryDiv.querySelector('.favourite-pin[data-active="true"]');
        let excludedSlide = null;
        if (pin) {
            minSlide = 1;
            excludedSlide = slides[0];
        }

        let nextSlideIndex = wrap(minSlide + moveCount, minSlide, maxSlide);
        let nextSlideDiv = slides[nextSlideIndex];

        if (moveRight) {
            bringCardToBack(categoryDiv, minSlide);
            const pinnedSlide = pin?.closest('.slide');
            if (pinnedSlide) {
                pinnedSlide.style.zIndex = 99;
            }
            adjustSlidePosition(categoryDiv, 1, excludedSlide);
        } else {
            bringCardToBack(categoryDiv, nextSlideIndex);
            curSlideDiv?.parentElement?.insertBefore(nextSlideDiv, slides[minSlide]);
            let newSlides = [...categoryDiv.querySelectorAll(".slide")];
            let newSlidesSubset = newSlides.slice(minSlide, newSlides.length);
            let indexAt0 = pin ? 0 : 1;
            setSlidesTranslateX(newSlidesSubset, indexAt0);
        }

        if (moveRight) {
            setTimeout(() => {
                curSlideDiv?.parentElement?.appendChild(slides[minSlide]);
                adjustSlidePosition(categoryDiv, 0);
            }, 500);
        } else {
            setTimeout(() => {
                adjustSlidePosition(categoryDiv, 0);
            }, 100);
        }
    }

    const bringCardToBack = (categoryDiv, index) => {
        var slides = [...categoryDiv.querySelectorAll(".slide")];
        slides.forEach((slide, idx) => {
            // Bring slide to back for better animation
            if (idx === index) {
                slide.style.zIndex = 0;
            } else {
                slide.style.zIndex = 1;
            }
        });
    }

    const moveSliderRight = (curSlideDiv) => {
        moveSlider(curSlideDiv, true);
    }

    const moveSliderLeft = (curSlideDiv) => {
        moveSlider(curSlideDiv, false);
    }

    const setPositionNumber = (categoryDiv) => {
        let slides = categoryDiv?.querySelectorAll('.slide');
        let position = 0;
        slides.forEach((slide) => {
            slide.setAttribute('data-sort-position', position++);
        });
    }

    const nextSlideListener = (event) => {
        const categoryDiv = event.currentTarget.closest('[data-category-id]');
        const curSlideDiv = categoryDiv.querySelector('.slide.shown-in-slider');
        if (!lockSlide) {
            lockSlide = true;
            moveSliderRight(curSlideDiv);
            setTimeout(() => {
                lockSlide = false;
            }, 500);
        }
    }

    const prevSlideListener = (event) => {
        const categoryDiv = event.currentTarget.closest('[data-category-id]');
        const curSlideDiv = categoryDiv.querySelector('.slide.shown-in-slider');
        if (!lockSlide) {
            lockSlide = true;
            moveSliderLeft(curSlideDiv);
            setTimeout(() => {
                lockSlide = false;
            }, 500);
        }
    }

    const setupSlider = (categoryDiv, curSlide = 0) => {
        adjustSlidePosition(categoryDiv, curSlide);
        setPositionNumber(categoryDiv);

        // select next slide button
        const nextSlide = categoryDiv?.querySelector(".btn-next");

        // add event listener and navigation functionality
        nextSlide?.addEventListener("click", nextSlideListener);

        // select prev slide button
        const prevSlide = categoryDiv?.querySelector(".btn-prev");

        // add event listener and navigation functionality
        prevSlide?.addEventListener("click", prevSlideListener);

        setupSliderSwipe(categoryDiv);
    }

    const touchStartListener = (event) => {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }

    const touchEndListener = (event) => {
        const categoryDiv = event.currentTarget.closest('[data-category-id]');

        let slide = null;
        if (isHomeDesignsCategory(categoryDiv)) {
            slide = event.currentTarget.closest('.slide');
        } else {
            slide = event.currentTarget;
        }

        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;

        if ((touchendX + sensitivity) < touchstartX) {
            moveSliderRight(slide);
        }

        if ((touchendX - sensitivity) > touchstartX) {
            moveSliderLeft(slide);
        }
    }

    const setupSliderSwipe = (categoryDiv) => {
        const slides = categoryDiv?.querySelectorAll(".slide");
        slides.forEach((slide) => {
            if (isHomeDesignsCategory(categoryDiv)) {
                const swipeSection = slide.querySelector('.swipe-section');
                swipeSection?.addEventListener('touchstart', touchStartListener, false);
                swipeSection?.addEventListener('touchend', touchEndListener, false);
            } else {
                slide?.addEventListener('touchstart', touchStartListener, false);
                slide?.addEventListener('touchend', touchEndListener, false);
            }
        });
    }

    const getCurrentSlidePosition = (slides, currentSlideId) => {
        let curPos = 0;
        for (let i = 0; i < slides.length; i++) {
            const id = slides[i].querySelector('.favouritable').getAttribute('data-id');
            if (id === currentSlideId) {
                curPos = i;
                break;
            }
        }
        return curPos;
    }

    const showPinOnSlider = (category, itemId) => {
        const categoryDiv= document.querySelector(`div[data-category-id='${category}']`)
        const slides = categoryDiv.querySelectorAll('.slide');
        let curIndex = getCurrentSlidePosition(slides, itemId);
        slides.forEach((slide) => {
            slide?.classList?.remove('shown-in-slider');
        });
        slides[curIndex]?.classList?.add('shown-in-slider');
        adjustSlidePosition(categoryDiv, curIndex);
    }

    const reorderByPin = (category, itemId) => {
        const favouritables = [...document.querySelectorAll(`div[data-category-id='${category}'] .slide`)];

        favouritables.sort((elementA, elementB) => {
            const pinA = elementA.querySelector('.favourite-pin').getAttribute('data-active') === 'true' ? 1 : 0;
            const pinB = elementB.querySelector('.favourite-pin').getAttribute('data-active') === 'true' ? 1 : 0;

            return pinB - pinA;
        });

        favouritables.forEach((favouritable) => {
            const parent = favouritable.parentElement;

            parent.appendChild(favouritable);
        })

        setPositionNumber(document.querySelector(`div[data-category-id='${category}']`));
        showPinOnSlider(category, itemId);
        reorderMobilePins(category);
    };

    const reorderMobilePins = (category) => {
        const categoryDiv = document.querySelector(`div[data-category-id='${category}']`);

        const slides = [...categoryDiv.querySelectorAll('.slide')];
        slides.sort((elementA, elementB) => {
            const posA = elementA.getAttribute('data-sort-position');
            const posB = elementB.getAttribute('data-sort-position');

            return posA - posB;
        });

        let favouritableIds = [];
        slides?.forEach((slide) => {
            let favouritable = slide.querySelector('.favouritable');
            favouritableIds.push(favouritable?.getAttribute(['data-id']));
        });

        let newMobilePinsOrder = [];
        favouritableIds.forEach((id) => {
            let pin = categoryDiv?.querySelector(`.mobile-pin[data-mobile-pin-item-id='${id}']`);
            newMobilePinsOrder.push(pin);
        });

        newMobilePinsOrder.forEach((mobilePin) => {
            const parent = mobilePin.parentElement;
            parent.appendChild(mobilePin);
        })
    };

    const mobileUnpinListener = (event) => {
        let itemId = event.currentTarget.closest('.mobile-pin')?.getAttribute('data-mobile-pin-item-id');
        if (itemId) {
            let pinButton = document.querySelector(`[data-pin-favourite-item-id='${itemId}']`);
            if (pinButton) {
                togglePinButton(pinButton);
            }
        }
    }

    const togglePinButton = (pinButton) => {
        const state = pinButton.getAttribute('data-active') === 'true';
        pinButton.setAttribute('data-active', (!state).toString());

        const categoryDiv = pinButton.closest('[data-category-id]');
        const category = categoryDiv?.getAttribute('data-category-id');

        let itemId = pinButton.closest('.favouritable').getAttribute('data-id');

        if (state) {
            hideMobilePin(itemId);
        } else {
            showMobilePin(itemId);
        }

        reorderByPin(category, itemId);
        updateMobilePinsCount(categoryDiv);
        enablePinButtons(categoryDiv);
    }

    const enablePinButtons = (categoryDiv) => {
        if (mobileState.matches) {
            const activePinButtons = categoryDiv?.querySelectorAll('.favourite-pin[data-active="true"]');
            if (activePinButtons.length >= maxMobilePins) {
                const inactivePinButtons = categoryDiv?.querySelectorAll('.favourite-pin[data-active]:not([data-active="true"])');
                inactivePinButtons.forEach((pin) => {
                    pin.setAttribute('disabled', '');
                });
            } else {
                const pinButtons = categoryDiv?.querySelectorAll('.favourite-pin');
                pinButtons.forEach((pin) => {
                    pin.removeAttribute('disabled');
                });
            }
        }
    }

    const showMobilePin = (itemId) => {
        let mobilePin = document.querySelector(`[data-mobile-pin-item-id='${itemId}']`);
        if (mobilePin) {
            mobilePin.classList.remove('hidden');
        }
    }

    const hideMobilePin = (itemId) => {
        let mobilePin = document.querySelector(`[data-mobile-pin-item-id='${itemId}']`);
        if (mobilePin) {
            mobilePin.classList.add('hidden');
        }
    }

    let mobileUnpinButtons = document.querySelectorAll('.mobile-unpin');
    mobileUnpinButtons.forEach((mobileUnpinButton) => {
        mobileUnpinButton.addEventListener('click', mobileUnpinListener);
    });

    const updateMobilePinsCount = (categoryDiv) => {
        const mobilePins = categoryDiv.querySelectorAll(".mobile-pin:not(.hidden)");
        let count = mobilePins.length;

        const mobilePinsCount = categoryDiv.querySelector(".mobile-pins-count");
        if (mobilePinsCount) {
            const shownCount = mobilePinsCount.querySelector(".shown-count");
            if (shownCount) {
                shownCount.innerHTML = count;
            }

            const totalCount = mobilePinsCount.querySelector(".total-count");
            if (totalCount) {
                totalCount.innerHTML = maxMobilePins;
            }

            if (count > 0) {
                mobilePinsCount.classList.remove('hidden');
            } else {
                mobilePinsCount.classList.add('hidden');
            }
        }
    }

    const updateSliderTitle = (slide, pos) => {
        if (pos === 0) {
            let title = slide?.querySelector('.favouritable')?.getAttribute('data-title');
            let sliderTitleDiv = slide?.closest('[data-category-id]')?.querySelector('.slider-title');
            if (sliderTitleDiv) {
                sliderTitleDiv.innerHTML = title;
            }
        }
    }

    const pinButtonListener = (event) => {
        const currentPinButton = event.currentTarget;

        const categoryDiv = currentPinButton.closest('[data-category-id]');

        // In desktop mode, pin only one item at a time.
        if (!mobileState.matches && isHomeDesignsCategory(categoryDiv)) {
            const activePinButtons = categoryDiv?.querySelectorAll('.favourite-pin[data-active="true"]');
            activePinButtons.forEach((pin) => {
                if (pin !== currentPinButton) {
                    togglePinButton(pin);
                }
            });
        }

        togglePinButton(currentPinButton);
    }

    const favouriteButtonListener = (event) => {
        const button = event.currentTarget;
        const favouritable = button.closest('.favouritable');
        const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');
        if (button.dataset.active === 'true') {
            if (confirmContainer && promptUnfavourite === 'true') {
                confirmContainer.dataset.active = 'true';
            } else {
                unFavouriteItem(button);
                if (confirmContainer) {
                    removeFavouritable(favouritable);
                }
            }
        } else {
            favouriteCookies.push(button.dataset.favouriteId);

            button.classList.add('gtm-unfavourite');
            button.classList.remove('gtm-favourite');
            button.dataset.active = 'true';

            createCookie('favourites', JSON.stringify(favouriteCookies), 365);
            updateHeaderFavourites(1);
        }
    }

    const mobilePinListener = (event) => {
        const pin = event.currentTarget;
        let itemId = pin.closest('.mobile-pin')?.getAttribute('data-mobile-pin-item-id');
        const category = pin.closest('[data-category-id]').getAttribute('data-category-id');
        showPinOnSlider(category, itemId);
    }

    const confirmFavouriteRemovalEventListener = (event) => {
        const confirmButton = event.currentTarget;
        const favouritable = confirmButton.closest('.favouritable');
        const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');
        setPromptUnfavouriteCookie(confirmContainer);

        const button = favouritable?.querySelector('button[data-favourite-id]');
        unFavouriteItem(button);
        removeFavouritable(favouritable);
    }

    const closeConfirmationEventListener = (event) => {
        const button = event.currentTarget;
        const favouritable = button.closest('.favouritable');
        const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');
        confirmContainer.dataset.active = 'false';
    }

    const updateCounter = (categoryDiv) => {
        let counter = categoryDiv.querySelector('.favourites-counter');
        let favouritableCount = categoryDiv.querySelectorAll('.favouritable')?.length;
        if (counter) {
            counter.innerHTML = favouritableCount;
        }
    }

    const loadMore = (categoryDiv) => {
        const category = categoryDiv.getAttribute('data-category-id');
        updateOffsets(categoryDiv, false);
        const cards = categoryDiv.querySelectorAll('.favouritable');
        cards.forEach((cardElement, index) => {
            if (index < offsets[category]) {
                cardElement.setAttribute('data-loaded', 'true');
            }
        });

        const loadMoreButton = categoryDiv.querySelector('button.load-more');
        const shownCards = cards.length;
        const loadedCards = categoryDiv.querySelectorAll('.favouritable[data-loaded="true"]').length;

        if (loadedCards < shownCards) {
            loadMoreButton?.classList.remove('hidden');
        } else {
            loadMoreButton?.classList.add('hidden');
        }
    }

    const loadAll = (categoryDiv) => {
        const cards = categoryDiv.querySelectorAll('.favouritable');
        cards.forEach((cardElement, index) => {
            cardElement.setAttribute('data-loaded', 'true');
        });
    }

    const updateOffsets = (categoryDiv, reset) => {
        const category = categoryDiv.getAttribute('data-category-id');
        if (reset) {
            offsets[category] = 0;
        } else {
            offsets[category] = offsets[category] + limit;
        }
    };

    const loadMoreButtonEventListener = (event) => {
        const button = event.currentTarget;
        const categoryDiv = button.closest('[data-category-id]');
        loadMore(categoryDiv);
    }

    const isHomeDesignsCategory = (categoryDiv) => {
        const category = categoryDiv?.getAttribute('data-category-id');
        return (category === 'home-designs-panel');
    }

    const mediaQueryListener = (event) => {
        const categoryDivs = document.querySelectorAll('[data-category-id]');
        categoryDivs.forEach((categoryDiv) => {
            const nextButton = categoryDiv.querySelector('.btn-next');
            const prevButton = categoryDiv.querySelector('.btn-prev');
            lockSlide = false;
            prevButton?.click();
            setTimeout(() => {
                lockSlide = false;
                nextButton?.click();
            }, 100);
        });
    };

    const clickCloseModalButtonListener = (e) => {
        const button = e.target;
        const modal = button.closest('dialog.unfavourite-modal');
        modal?.close();
    }

    const closeModalListener = (e) => {
        unlockBody();
    }

    const unfavouriteAll = (container) => {
        const allSectionButtons = container.querySelectorAll('button[data-favourite-id]');
        allSectionButtons.forEach((button) => button.click());
    }

    const confirmUnfavouriteAll = (e) => {
        const confirmButton = e.target;
        const modal = confirmButton.closest('dialog.unfavourite-modal');
        const category = document.querySelector('[data-showing-category]')?.getAttribute('data-showing-category');
        const container = document.querySelector(`[data-category-id="${category}"]`);
        setPromptUnfavouriteCookie(modal);

        const initialPromptUnfavourite = promptUnfavourite;
        promptUnfavourite = 'false';
        unfavouriteAll(container);
        modal?.close();
        promptUnfavourite = initialPromptUnfavourite;
    }

    const setPromptUnfavouriteCookie = (container) => {
        const dontShowAgain = container?.querySelector('input[type="checkbox"]');

        if (dontShowAgain.checked) {
            createCookie('prompt-unfavourite','false',365);
            promptUnfavourite = 'false';
        }
    }

    const setupOnLoad = () => {
        let favouriteButtons = document.querySelectorAll('.contains-favourites [data-favourite-id]');
        favouriteButtons.forEach((button) => {
            const favouritable = button.closest('.favouritable');
            const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');

            //check cookies if an elevation has been favourited & apply visual based on result of above check
            if (favouriteCookies.indexOf(button.dataset.favouriteId) !== -1) {
                button.dataset.active = 'true';
                button.classList.add('gtm-unfavourite');
                button.classList.remove('gtm-favourite');
            } else {
                button.classList.add('gtm-favourite');
                button.classList.remove('gtm-unfavourite');
            }

            button.addEventListener('click', favouriteButtonListener);

            if (confirmContainer) {
                confirmContainer.querySelector('button[data-confirm-removal]').addEventListener('click', confirmFavouriteRemovalEventListener);
                confirmContainer.querySelector('button[data-close-confirmation]').addEventListener('click', closeConfirmationEventListener);
            }
        });

        // pin cards
        let pinButtons = document.querySelectorAll('.favourite-pin');
        pinButtons.forEach((pinButton) => {
            pinButton.addEventListener('click', pinButtonListener);
        })

        // Initialise mobile elements
        const categoryDivs = document.querySelectorAll('[data-category-id]');

        categoryDivs.forEach((categoryDiv) => {
            let firstSlide = categoryDiv.querySelector('.slide');
            firstSlide?.classList.add('shown-in-slider');

            hideDivsWhenNoFavourites(categoryDiv);
            setupSlider(categoryDiv);
            updateCounter(categoryDiv);

            if (mobileState.matches || isHomeDesignsCategory(categoryDiv)) {
                loadAll(categoryDiv);
            } else {
                updateOffsets(categoryDiv, true);
                loadMore(categoryDiv);
                const loadMoreButton = categoryDiv.querySelector('button.load-more');
                loadMoreButton?.addEventListener('click', loadMoreButtonEventListener);
            }
        });

        const mobilePinTitles = document.querySelectorAll('.mobile-pin-title');
        mobilePinTitles.forEach((pin) => {
            pin.addEventListener('click', mobilePinListener);
        });

        mobileState.addEventListener("change", mediaQueryListener);

        // Clear-all favourites button
        document.querySelectorAll('button.clear-favourites').forEach((button) => {
            button.addEventListener('click', (event) => {
                const container = button.closest('div[data-category-id]');

                if (promptUnfavourite !== 'false') {
                    lockBody();
                    const modal = document.querySelector('.unfavourite-modal').showModal();
                } else {
                    unfavouriteAll(container);
                }
            });
        });

        document.querySelectorAll('dialog.unfavourite-modal').forEach((modal) => {
            const closeButton = modal.querySelector('button[data-close-confirmation]');
            closeButton?.addEventListener('click', clickCloseModalButtonListener);

            modal.addEventListener('close', closeModalListener);

            const confirmButton = modal.querySelector('button[data-confirm-removal]');
            confirmButton?.addEventListener('click', confirmUnfavouriteAll);
        });
    }

    setupOnLoad();
});